<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 18px; ">
      <el-breadcrumb-item :to="{ name: 'Apimonitor' }">监控列表</el-breadcrumb-item>
      <el-breadcrumb-item>报表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-radio-group v-model="radio" style="float: right" @change="reportChange(radio)">
      <el-radio-button label="自定义时间"></el-radio-button>
      <el-radio-button label="日报"></el-radio-button>
      <el-radio-button label="周报"></el-radio-button>
      <el-radio-button label="月报"></el-radio-button>
    </el-radio-group>

    <div v-if="reportType== 'week'">
      <el-table
        :data="tableData"
        :header-cell-style="{'textAlign':'center'}"
        :cell-style="{'textAlign':'center'}"
        style="width: 100%">
        <el-table-column prop="WeekTh" label="名称"></el-table-column>
        <el-table-column prop="StartTime" label="开始时间"></el-table-column>
        <el-table-column prop="EndTime" label="结束时间"></el-table-column>
        <el-table-column align="center" label="操作">
          <template v-slot="{row}">
            <el-button size="mini" type="primary" @click="logDetail(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-table v-if="reportType== 'day' || reportType== 'month'"
              :data="tableData"
              :header-cell-style="{'textAlign':'center'}"
              :cell-style="{'textAlign':'center'}"
              style="width: 100%">
      <el-table-column prop="time" label="日期"></el-table-column>
      <el-table-column align="center" label="操作">
        <template v-slot="{row}">
          <el-button size="mini" type="primary" @click="logDetail(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
  </div>
</template>

<script>
  export default {
    name: "ReportList",
    data() {
      return {
        radio: "日报",
        tableData: [],
        currentPage: 1,
        pageSize: 10,
        totalElement: 0,
        reportType: "day"
      }
    },
    created() {
      this.getReportList()
    },
    methods: {
      logDetail(row) {
        let showStartTime = '';
        let showEndTime = '';
        if (this.reportType == 'day') {
          showStartTime = row.time;
          showEndTime = row.time;
        } else if (this.reportType == 'week') {
          showStartTime = row.StartTime.split("T")[0];
          showEndTime = row.EndTime.split("T")[0];
        } else {
          showStartTime = row.time;
          showEndTime = row.time;
        }
        this.$router.push({
          path: 'reportDetail',
          name: 'ReportDetail',
          params: {
            reportType: this.reportType,
            showStartTime: showStartTime,
            showEndTime: showEndTime,
          }
        })
      },
      reportChange(e) {
        if (e == "日报") {
          this.reportType = "day";
        } else if (e == "周报") {
          this.reportType = "week";
        } else if(e == "月报"){
          this.reportType = "month";
        }else {
          this.reportType = "custom";
          this.$router.push({
            path: 'reportDetail',
            name: 'ReportDetail',
            params: {
              reportType: this.reportType
            }
          })
        }
        if (this.reportType != 'custom') {
          this.getReportList()
        }
      },
      getReportList() {
        let data = {
          "type": this.reportType,
          "pageNo": this.currentPage,
          "pageSize": this.pageSize
        };
        this.$axios.post(this.apiUrl + 'apimonitor/getStatisticDay', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              if (this.reportType == "week") {
                this.tableData = data.data;
              } else {
                this.tableData = data.list
              }
              this.totalElement = data.total;
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getReportList()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getReportList()
      }

    }
  }
</script>

<style scoped>

</style>
